import { useState } from "react";
import { Lock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { prototypeApi, setToken, apiErrorMessage } from "@/lib/prototypeApi";

export function PrototypeGate({ onAuthed }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!password || loading) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await prototypeApi.login(password);
      setToken(data.token);
      onAuthed();
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-re-ink px-6" data-testid="prototype-gate">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl md:p-10">
        <div className="mb-8 flex items-center justify-between">
          <Logo variant="dark" emblemY={6} />
          <span className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1 text-xs font-medium text-white/70">
            <Lock className="h-3.5 w-3.5" /> Prototype
          </span>
        </div>
        <h1 className="font-heading text-2xl font-bold text-white">Beveiligde toegang</h1>
        <p className="mt-2 text-sm text-white/60">
          Voer het prototype-wachtwoord in om de Rendy-integratie te openen.
        </p>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="prototype-password" className="text-white/80">
              Wachtwoord
            </Label>
            <Input
              id="prototype-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Wachtwoord"
              autoFocus
              data-testid="prototype-password-input"
              className="border-white/15 bg-white/5 text-white placeholder:text-white/30"
            />
          </div>
          {error && (
            <p className="text-sm text-re-crimson" data-testid="prototype-login-error">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading || !password}
            data-testid="prototype-login-button"
            className="w-full rounded-full bg-re-red py-6 text-base font-semibold text-white hover:bg-re-deepred"
          >
            {loading ? "Bezig met inloggen…" : "Toegang krijgen"}
          </Button>
        </form>
      </div>
    </div>
  );
}
